import { Box, Grid, Stack, Theme, Typography, useTheme } from "@mui/material";

import {
  selectCategories,
  updateCategorySelection,
  selectCategoriesSelected,
} from "@/global/store/data/gameFilters";
import { useAppDispatch, useAppStore } from "@/global/store";

export function CategorySelector(props: { title?: string }) {
  const dispatch = useAppDispatch();
  const categories = useAppStore(selectCategories);
  const selectedCategories = useAppStore(selectCategoriesSelected);

  const handleSelect = (category: string) => {
    dispatch(updateCategorySelection(category));
  };

  return (
    <Box maxHeight={"450px"} overflow={"auto"} p={"2px"}>
      {props?.title ? (
        <Box>
          <Typography
            variant="subtitle1"
            fontWeight={"700"}
            color="text.primary"
          >
            {props?.title}
          </Typography>
        </Box>
      ) : null}

      <Box mt={2}>
        <Grid container spacing={3}>
          {categories?.map((itm, idx) => {
            return (
              <Grid key={idx} item xs={6} md={3}>
                <Category
                  name={itm}
                  isSelected={selectedCategories?.includes(itm) || false}
                  onSelect={handleSelect}
                />
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
}

interface CategoryProps {
  name: string;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

function Category(props: CategoryProps) {
  const theme = useTheme();
  const styles = useStyles(theme, { isSelected: props.isSelected });

  return (
    <Box onClick={() => props.onSelect(props.name)} sx={styles.categoryCard}>
      <Stack justifyContent={"center"} alignItems={"center"}>
        <Typography variant="body1" color="text.primary">
          {props.name}
        </Typography>
      </Stack>
    </Box>
  );
}

function useStyles(theme: Theme, state: { isSelected: boolean }) {
  return {
    categoryCard: {
      outline: `${state.isSelected ? "2px" : "1px"} solid ${
        state.isSelected ? theme.palette.primary.main : theme.palette.divider
      }`,
      borderRadius: 0.8,
      padding: 1,
      transition: "all 0.3s ease",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  };
}
